/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identificaçãoentifier: Apache-2.0
 */

export const savedCartDetails = {
  cartName: 'Nome',
  cartDescription: 'Descrição',
  cartId: 'IDENTIFICAÇÃO',
  dateSaved: 'Data de salvamento',
  items: 'Artigos',
  quantity: 'Quantidade',
  total: 'Total',
  editSavedCart: 'Editar carrinho salvo',
  deleteSavedCart: 'Excluir carrinho salvo',
  addSelectedItems: 'Adicionar itens selecionados',
  emptyCartItems: 'Empty Cart Artigos',
};

export const savedCartList = {
  savedCarts: 'Carrinhos Guardados ({{count}})',
  cartName: 'Nome',
  weight: 'Peso Total (KG)',
  description: 'Descrição',
  cartId: 'Identificação',
  dateSaved: 'Data de salvamento',
  cartDescription: 'Descrição',
  quantity: 'Quantidade',
  total: 'Total',
  actions: 'Ações',
  makeCartActive: 'Ative o carrinho',
  notFound: 'Nenhum carrinho salvo encontrado',
  swapCartNoActiveCart:
    'O carrinho existente é ativado por {{{cartName}} com sucesso.',
  swapCartWithActiveCart:
    'O carrinho existente é ativado por {{{{cartName}} com sucesso. Your previous items were saved in a cart {{{{previousCartName}}.',
};

export const savedCartCartPage = {
  messages: {
    cartSalvard:
      'Your cart items have been successfully saved for later in the "{{cartName}}" cart',
  },
};

export const savedCartDialog = {
  saveForLater: 'Salvar para mais tarde',
  itemsSavedForLater: 'Todos os itens do seu carrinho serão salvos para mais tarde',
  savedCartName: 'Número do carrinho salvo',
  savedCartDescription: 'Descrição',
  optional: 'opcional',
  charactersLeft: 'Caracteres à esquerda: {{count}}',
  cancel: 'Cancelar',
  save: 'Salvar',
  restore: 'Restaurar',
  followingCartDelete: 'O próximo carrinho salvo será excluído',
  followingCartRestore:
    'O próximo carrinho salvo será restaurado como o carrinho ativo',
  delete: 'Apagar',
  deleteCartSuccess: 'Trolley desligado com sucesso',
  editCartSuccess: 'Carrinho editado com sucesso',
  editSavedCart: 'Editar carrinho salvo',
  deleteSavedCart: 'Excluir carrinho salvo',
  restoreSavedCart: 'Restaurar Carrinhos Salvos',
  name: 'Nome',
  id: 'IDENTIFICAÇÃO',
  description: 'Descrição',
  quantity: 'Quantidade',
  total: 'Total',
  keepCopySavedCart: 'Salve uma cópia deste carrinho na lista de carrinhos salvos',
  defaultCloneCartNúmero: 'Cópia de {{{name}}',
  nameOfCloneCart: 'Número do carrinho copiado',
};

export const addToSavedCart = {
  savedCarts: 'Carrinhos salvos',
  saveCartForLater: 'Salve o carrinho para mais tarde',
};

export const savedCart = {
  savedCartDetails,
  savedCartList,
  savedCartCartPage,
  savedCartDialog,
  addToSavedCart,
};
